import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@web/store'
import { isKnownRoute } from '../actions'
import { configureModalBuilder, useModalBuilder } from '../useModalBuilder'
import BuilderModal from './BuilderModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderModalHost',
  setup(__props) {

const store = useStore()
const router = useRouter()
const { current, load, markShown, close, clickButton } = useModalBuilder()

configureModalBuilder({
  isKnownRoute: path => isKnownRoute(router, path),
  navigate: path => { router.push(path) }
})

// Вход, автологин, смена аккаунта — перечитываем список; выход — очищаем.
// flush: 'sync' — загрузка стартует сразу, до триггеров страниц, и не зависит от очереди
// рендера: упавшее обновление чужого компонента не должно съесть смену пользователя.
const userId = computed<number | null>(() => store.getters['user/user']?.id ?? null)
watch(userId, id => { load(id) }, { immediate: true, flush: 'sync' })

return (_ctx: any,_cache: any) => {
  return (_unref(current))
    ? (_openBlock(), _createBlock(BuilderModal, {
        key: _unref(current).modalId,
        rule: _unref(current),
        onShown: _unref(markShown),
        onClose: _unref(close),
        onCta: _unref(clickButton)
      }, null, 8, ["rule", "onShown", "onClose", "onCta"]))
    : _createCommentVNode("", true)
}
}

})